/* eslint-disable simple-import-sort/imports */
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */

import { library } from '@fortawesome/fontawesome-svg-core';

// Brands
import { faAppStore as fabAppStore } from '@fortawesome/free-brands-svg-icons/faAppStore';
import { faGooglePlay as fabGooglePlay } from '@fortawesome/free-brands-svg-icons/faGooglePlay';
import { faFacebook as fabFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram as fabInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin as fabLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faPinterest as fabPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import { faTiktok as fabTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok';
import { faTumblr as fabTumblr } from '@fortawesome/free-brands-svg-icons/faTumblr';
import { faTwitter as fabTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faXTwitter as fabXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faYoutube as fabYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faBloggerB as fabBloggerB } from '@fortawesome/free-brands-svg-icons/faBloggerB';

// Regular
import { faAt as farAt } from '@fortawesome/pro-regular-svg-icons/faAt';
import { faAward as farAward } from '@fortawesome/pro-regular-svg-icons/faAward';
import { faAddressCard as farAddressCard } from '@fortawesome/pro-regular-svg-icons/faAddressCard';
import { faBadge as farBadge } from '@fortawesome/pro-regular-svg-icons/faBadge';
import { faCalendar as farCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faCircleDollar as farCircleDollar } from '@fortawesome/pro-regular-svg-icons/faCircleDollar';
import { faCertificate as farCertificate } from '@fortawesome/pro-regular-svg-icons/faCertificate';
import { faClock as farClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faDownload as farDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faEnvelope as farEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faFileCertificate as farFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faHandWave as farHandWave } from '@fortawesome/pro-regular-svg-icons/faHandWave';
import { faHandshake as farHandshake } from '@fortawesome/pro-regular-svg-icons/faHandshake';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faMemoCircleCheck as farMemoCircleCheck } from '@fortawesome/pro-regular-svg-icons/faMemoCircleCheck';
import { faPrint as farPrint } from '@fortawesome/pro-regular-svg-icons/faPrint';
import { faMagnifyingGlass as farMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass';
import { faMagnifyingGlassPlus as farMagnifyingGlassPlus } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlassPlus';
import { faStroopwafel as farStroopwafel } from '@fortawesome/pro-regular-svg-icons/faStroopwafel';
import { faTriangleExclamation as farTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { faUser as farUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faBookReader as farBookReader } from '@fortawesome/pro-regular-svg-icons/faBookReader';
import { faList as farList } from '@fortawesome/pro-regular-svg-icons/faList';
import { faMegaphone as farMegaphone } from '@fortawesome/pro-regular-svg-icons/faMegaphone';
import { faGraduationCap as farGraduationCap } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import { faChartLine as farChartLine } from '@fortawesome/pro-regular-svg-icons/faChartLine';
import { faExclamationCircle as farExclamationCircle } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';

// Solid
import { faAward as fasAward } from '@fortawesome/pro-solid-svg-icons/faAward';
import { faAlignRight as fasAlignRight } from '@fortawesome/pro-solid-svg-icons/faAlignRight';
import { faAngleLeft as fasAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faAngleRight as fasAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faArrowDown as fasArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import { faAt as fasAt } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faBan as fasBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faBars as fasBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBookReader as fasBookReader } from '@fortawesome/pro-solid-svg-icons/faBookReader';
import { faBug as fasBug } from '@fortawesome/pro-solid-svg-icons/faBug';
import { faBuilding as fasBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faBullhorn as fasBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faCaretDown as fasCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretLeft as fasCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import { faChartLine as fasChartLine } from '@fortawesome/pro-solid-svg-icons/faChartLine';
import { faChartBar as fasChartBar } from '@fortawesome/pro-solid-svg-icons/faChartBar';
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle as fasCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronUp as fasChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronDown as fasChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleNotch as fasCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faCity as fasCity } from '@fortawesome/pro-solid-svg-icons/faCity';
import { faClipboardCheck as fasClipboardCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck';
import { faClock as fasClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faDownload as fasDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faEnvelope as fasEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faExclamationCircle as fasExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faFilePdf as fasFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faFax as fasFax } from '@fortawesome/pro-solid-svg-icons/faFax';
import { faFlagCheckered as fasFlagCheckered } from '@fortawesome/pro-solid-svg-icons/faFlagCheckered';
import { faFileInvoiceDollar as fasFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons/faFileInvoiceDollar';
import { faFilter as fasFilter } from '@fortawesome/pro-solid-svg-icons/faFilter';
import { faGlobe as fasGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faGraduationCap as fasGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faHandshake as fasHandshake } from '@fortawesome/pro-solid-svg-icons/faHandshake';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHome as fasHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faImages as fasImages } from '@fortawesome/pro-solid-svg-icons/faImages';
import { faInfo as fasInfo } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faKey as fasKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faList as fasList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faLink as fasLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faLock as fasLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faLongArrowLeft as fasLongArrowLeft } from '@fortawesome/pro-solid-svg-icons/faLongArrowLeft';
import { faMap as fasMap } from '@fortawesome/pro-solid-svg-icons/faMap';
import { faMapMarker as fasMapMarker } from '@fortawesome/pro-solid-svg-icons/faMapMarker';
import { faMapMarkerAlt as fasMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt';
import { faMegaphone as fasMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faPhone as fasPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faPrint as fasPrint } from '@fortawesome/pro-solid-svg-icons/faPrint';
import { faSearch as fasSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faSearchPlus as fasSearchPlus } from '@fortawesome/pro-solid-svg-icons/faSearchPlus';
import { faShare as fasShare } from '@fortawesome/pro-solid-svg-icons/faShare';
import { faShareAlt as fasShareAlt } from '@fortawesome/pro-solid-svg-icons/faShareAlt';
import { faShieldAlt as fasShieldAlt } from '@fortawesome/pro-solid-svg-icons/faShieldAlt';
import { faSignOutAlt as fasSignOutAlt } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt';
import { faStore as fasStore } from '@fortawesome/pro-solid-svg-icons/faStore';
import { faStroopwafel as fasStroopwafel } from '@fortawesome/pro-solid-svg-icons/faStroopwafel';
import { faTasks as fasTasks } from '@fortawesome/pro-solid-svg-icons/faTasks';
import { faTimesCircle as fasTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { faThList as fasThList } from '@fortawesome/pro-solid-svg-icons/faThList';
import { faTreasureChest as fasTreasureChest } from '@fortawesome/pro-solid-svg-icons/faTreasureChest';
import { faTimes as fasTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faTrophy as fasTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy';
import { faPlay as fasPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUpload as fasUpload } from '@fortawesome/pro-solid-svg-icons/faUpload';
import { faVideo as fasVideo } from '@fortawesome/pro-solid-svg-icons/faVideo';
import { faWindowClose as fasWindowClose } from '@fortawesome/pro-solid-svg-icons/faWindowClose';
import { faSignInAlt as fasSignInAlt } from '@fortawesome/pro-solid-svg-icons/faSignInAlt';
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faCommentDots as fasCommentDots } from '@fortawesome/pro-solid-svg-icons/faCommentDots';
import { faFileCertificate as fasFileCertificate } from '@fortawesome/pro-solid-svg-icons/faFileCertificate';

const exports = {
  fabAppStore,
  fabGooglePlay,
  fabFacebook,
  fabInstagram,
  fabLinkedin,
  fabPinterest,
  fabTiktok,
  fabTumblr,
  fabTwitter,
  fabXTwitter,
  fabYoutube,
  fabBloggerB,
  farAt,
  farAward,
  farAddressCard,
  farBadge,
  farCalendar,
  farCheckCircle,
  farCircleDollar,
  farCertificate,
  farClock,
  farDownload,
  farEnvelope,
  farFileCertificate,
  farHandWave,
  farHandshake,
  farHeart,
  farMemoCircleCheck,
  farPrint,
  farMagnifyingGlass,
  farMagnifyingGlassPlus,
  farStroopwafel,
  farTriangleExclamation,
  farUser,
  farBookReader,
  farList,
  farMegaphone,
  farGraduationCap,
  farChartLine,
  farExclamationCircle,
  fasAward,
  fasAlignRight,
  fasAngleLeft,
  fasAngleRight,
  fasArrowDown,
  fasAt,
  fasBan,
  fasBars,
  fasBookReader,
  fasBug,
  fasBuilding,
  fasBullhorn,
  fasCaretDown,
  fasCaretLeft,
  fasChartLine,
  fasChartBar,
  fasCheck,
  fasCheckCircle,
  fasChevronLeft,
  fasChevronUp,
  fasChevronDown,
  fasCircle,
  fasCircleNotch,
  fasCity,
  fasClipboardCheck,
  fasClock,
  fasDownload,
  fasEnvelope,
  fasExclamationCircle,
  fasFilePdf,
  fasFax,
  fasFlagCheckered,
  fasFileInvoiceDollar,
  fasFilter,
  fasGlobe,
  fasGraduationCap,
  fasHandshake,
  fasHeart,
  fasHome,
  fasImages,
  fasInfo,
  fasKey,
  fasList,
  fasLink,
  fasLock,
  fasLongArrowLeft,
  fasMap,
  fasMapMarker,
  fasMapMarkerAlt,
  fasMegaphone,
  fasPhone,
  fasPrint,
  fasSearch,
  fasSearchPlus,
  fasShare,
  fasShareAlt,
  fasShieldAlt,
  fasSignOutAlt,
  fasStore,
  fasStroopwafel,
  fasTasks,
  fasTimesCircle,
  fasThList,
  fasTreasureChest,
  fasTimes,
  fasTrophy,
  fasPlay,
  fasUser,
  fasUpload,
  fasVideo,
  fasWindowClose,
  fasSignInAlt,
  fasStar,
  fasCommentDots,
  fasFileCertificate,
};

export default library.add(...Object.values(exports));

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */